<template>
  <div v-if="disabled" class="circle_number disabled">
    <span>{{ text }}</span>
  </div>
  <div v-else class="circle_number primary primary--text">
    <span>{{ text }}</span>
  </div>
</template>
<script>
export default {
  props: {
    text: String,
    disabled: Boolean,
  },
}
</script>
<style scoped>
.disabled {
  color: #00000042 !important;
  border-color: #00000042 !important;
}
.circle_number {
  display: inline-flex;
  border-radius: 50%;
  border: 2px solid;
  padding: 3px 6px;
  background-color: initial !important;
  width: fit-content;
  height: fit-content;
  justify-content: center;
  align-items: center;
}
</style>
